import { ref, computed } from "vue"
import { useStore } from 'vuex'
import { identificationLevelUpgrade } from "../services/api.js"

const identificationLevelUpgradeHowtoText = ref('')
const identificationLevelUpgradeHelpActive = ref(false)
const isLoading = ref(false)

export function useIdentificationUpgrade() {
    const store = useStore()

    const authToken = computed(() => store.state.authToken)

    const upgradeLevel = async () => {
        isLoading.value = true
        const response = await identificationLevelUpgrade(authToken.value)

        if (response) {
            isLoading.value = false
        }

        if (response.verification_url) {
            window.location = response.verification_url
        } else {
            identificationLevelUpgradeHowtoText.value = response.howto_text
            identificationLevelUpgradeHelpActive.value = true
        }
    }

    return {
        identificationLevelUpgradeHelpActive,
        identificationLevelUpgradeHowtoText,
        upgradeLevel,
        isLoading
    }
}